var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-header",style:({'background-color': _vm.gameConfig.gameConfig[_vm.gameId].color})},[_c('label',[_vm._v(_vm._s(_vm._f("translate")(_vm.setGameName)))])])}
var staticRenderFns = []

export { render, staticRenderFns }